export const PDF_WORKER_SRC = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

export const configurePdfWorker = (pdfjs) => {
  if (pdfjs?.GlobalWorkerOptions) {
    pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;
  }
};
